// Geometric model heights (m) for Skysight's `uv_{height}` wind-at-altitude
// params. Captured from the live wind-altitude stepper (2026-06-09): 120 m steps
// to 1800 m, then 300 m steps. See docs/skysight-overlay-styles/wind/CAPTURE-NOTES.md.
// (Extend the top of the ladder if Skysight is found to go higher — verify at runtime.)
export const WIND_LEVELS = [
  120, 240, 360, 480, 600, 720, 840, 960, 1080, 1200, 1320, 1440, 1560, 1680, 1800,
  2100, 2400, 2700, 3000, 3300, 3600, 3900, 4200,
];

// ICON-D2 ladder (probed live 2026-06-11 against cf.skysight.io/composite):
// 600 m steps, uv_600 .. uv_4800; Skysight's ICON UI defaults to "Wind at 600m".
export const WIND_LEVELS_ICON = [600, 1200, 1800, 2400, 3000, 3600, 4200, 4800];

// Skysight defaults the altitude product to "Wind at 700m" = uv_720.
export const DEFAULT_WIND_LEVEL = 720;

export const levelsForModel = (model) => (model === 'ICON' ? WIND_LEVELS_ICON : WIND_LEVELS);

// Nearest level in the model's ladder — keeps a URL-carried level usable when
// the user switches models (e.g. uv_720 from EU snaps to uv_600 on ICON).
export const snapLevel = (level, model) => {
  const ladder = levelsForModel(model);
  return ladder.reduce((best, h) => (Math.abs(h - level) < Math.abs(best - level) ? h : best), ladder[0]);
};

export const paramForLevel = (height) => `uv_${height}`;

// Skysight's UI labels the level as the param height rounded to the nearest 100 m
// (uv_720 -> "700 m", uv_960 -> "1000 m").
export const labelForLevel = (height) => `${Math.round(height / 100) * 100} m`;
